import { motion } from "framer-motion";
import clsx from "clsx";

export default function ChatBubble({ from, text }) {
  const isBot = from === "bot";

  return (
    <motion.div
      initial={{ opacity: 0, y: 12, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.4, ease: [0.16, 1, 0.3, 1] }}
      className={clsx(
        "max-w-[85%] px-3.5 py-2.5 text-[12.5px] font-medium leading-[1.75] sm:text-[13px]",
        isBot
          ? "self-start rounded-2xl rounded-br-md bg-teal-soft text-teal-900 dark:!bg-teal-2/20 dark:!text-teal-900"
          : "self-end rounded-2xl rounded-bl-md bg-gradient-to-br from-gold to-gold-2 text-amber-950"
      )}
    >
      {text}
    </motion.div>
  );
}

export function TypingBubble() {
  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      className="self-start rounded-2xl rounded-br-md bg-teal-soft px-3.5 py-2.5 dark:!bg-teal-2/20"
    >
      <span className="inline-flex gap-[3px]">
        {[0, 1, 2].map((i) => (
          <motion.i
            key={i}
            animate={{ opacity: [0.3, 1, 0.3], y: [0, -2, 0] }}
            transition={{
              duration: 1.2,
              repeat: Infinity,
              delay: i * 0.15,
              ease: "easeInOut",
            }}
            className="inline-block h-1.5 w-1.5 rounded-full bg-teal-2"
          />
        ))}
      </span>
    </motion.div>
  );
}